var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationBlue(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 43.75,
    viewBox: "0 0 32 43.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#2196F3;}.b,.d{fill:#2196F3;}.b,.e{stroke:#fff;}.c{fill:#da5100;}.e{fill:#d83200;}.f,.h{fill:#fff;}.g,.h{stroke:none;}.i{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -0.25)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(12 39)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M 4 4.5 C 2.102799892425537 4.5 0.5 3.584110021591187 0.5 2.5 C 0.5 1.415889978408813 2.102799892425537 0.5 4 0.5 C 5.897200107574463 0.5 7.5 1.415889978408813 7.5 2.5 C 7.5 3.584110021591187 5.897200107574463 4.5 4 4.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M 4 1 C 3.129310131072998 1 2.291560173034668 1.211489915847778 1.7015700340271 1.580229997634888 C 1.255710124969482 1.858890056610107 1 2.194139957427979 1 2.5 C 1 2.805860042572021 1.255710124969482 3.141109943389893 1.7015700340271 3.419770002365112 C 2.291560173034668 3.788509845733643 3.129310131072998 4 4 4 C 4.87069034576416 4 5.708439826965332 3.788509845733643 6.2984299659729 3.419770002365112 C 6.744289875030518 3.141109943389893 7 2.805860042572021 7 2.5 C 7 2.194139957427979 6.744289875030518 1.858890056610107 6.2984299659729 1.580229997634888 C 5.708439826965332 1.211489915847778 4.87069034576416 1 4 1 M 4 0 C 6.209139823913574 0 8 1.119290113449097 8 2.5 C 8 3.880710124969482 6.209139823913574 5 4 5 C 1.790860176086426 5 0 3.880710124969482 0 2.5 C 0 1.119290113449097 1.790860176086426 0 4 0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(0 1.25)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 16,
    cy: 16,
    r: 16
  }), /*#__PURE__*/React.createElement("circle", {
    className: "i",
    cx: 16,
    cy: 16,
    r: 15.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(21 41) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M 9.150241851806641 8.5 L 0.8497577905654907 8.5 L 5 1.029564023017883 L 9.150241851806641 8.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M 5 2.059127807617188 L 1.699515342712402 8 L 8.300484657287598 8 L 5 2.059127807617188 M 5 0 L 10 9 L 0 9 L 5 0 Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M5,0l5,9H0Z",
    transform: "translate(21 39) rotate(180)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "e",
    transform: "translate(20 0.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M9.1,12.128H.433A.433.433,0,0,0,0,12.562v.866a.433.433,0,0,0,.433.433H9.1a.433.433,0,0,0,.433-.433v-.866A.433.433,0,0,0,9.1,12.128Zm5.631-8.663v-1.3a.433.433,0,1,0-.866,0v1.3h-.866v-1.3a.433.433,0,0,0-.866,0v1.3H11.7a.433.433,0,0,0-.433.433v.866A2.158,2.158,0,0,0,12.778,6.82v3.208a.788.788,0,0,1-.63.79.759.759,0,0,1-.886-.747V9.313A2.382,2.382,0,0,0,8.88,6.931H8.663v-5.2A1.733,1.733,0,0,0,6.931,0H2.6A1.733,1.733,0,0,0,.866,1.733v9.53h7.8V8.23H8.88A1.083,1.083,0,0,1,9.963,9.313v.666a2.12,2.12,0,0,0,1.852,2.139,2.059,2.059,0,0,0,2.263-2.047V6.82a2.158,2.158,0,0,0,1.516-2.056V3.9a.433.433,0,0,0-.433-.433h-.433ZM7.041,4.758,4.5,8.521a.336.336,0,0,1-.281.142.3.3,0,0,1-.316-.35l.623-2.249H2.924A.3.3,0,0,1,2.6,5.742l.433-2.9A.313.313,0,0,1,3.357,2.6H5.2a.3.3,0,0,1,.314.358L5.2,4.332H6.76A.286.286,0,0,1,7.041,4.758Z",
    transform: "translate(10 10.444)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationBlue);
export default __webpack_public_path__ + "static/media/locationBlue.1a6b439c79458425a9d7d533acf673ba.svg";
export { ForwardRef as ReactComponent };